import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const PersonCards = dynamic(() => import('./PersonCards'));

const PersonCardsConfig = {
  name: 'PersonCards',
  FriendlyName: 'Person Card',
  inputs: [
    {
      name: 'people',
      type: 'list',
      subFields: [
        {
          name: 'name',
          type: 'text',
          required: true,
        },
        {
          name: 'jobTitle',
          type: 'text',
          required: true,
        },
        {
          name: 'image',
          type: 'file',
          required: false,
        },
        {
          name: 'info',
          type: 'richText',
          required: true,
        },
        {
          name: 'profileLink',
          type: 'text',
          required: true,
        },
      ],
    },
  ],
};

Builder.registerComponent(PersonCards, PersonCardsConfig);
